module.exports = __webpack_public_path__ + "static/media/public.86b7711e.svg";